<!-- BnB MIN INFO, SLIDER, MAX INFO -->
<div *ngIf="mode === 'manual'" class="grid flex align-items-center mt-0">
	<!-- BnB MIN INFO MOBILE -->
	<div *ngIf="onExtendedMobile() && minTemp" class="col-6 flex justify-content-end py-0">
		<div class="flex flex-column w-16rem">
			<div class="flex align-items-center justify-content-center text-lg text-center">{{ 'MIN_VAR_AVAILABLE' | translate }}</div>
			<div class="flex align-items-center justify-content-center text-3xl">
				<div>{{minTemp}}°C</div>
			</div>
		</div>
	</div>
	<!-- BnB MAX INFO MOBILE -->
	<div *ngIf="onExtendedMobile() && maxTemp" class="col-6 flex justify-content-start py-0">
		<div class="flex flex-column w-16rem">
			<div class="flex align-items-center justify-content-center text-lg text-center">{{ 'MAX_VAR_AVAILABLE' | translate }}</div>
			<div class="flex align-items-center justify-content-center text-3xl font-normal">
				<div>{{maxTemp}}°C</div>
			</div>
		</div>
	</div>

	<!-- BnB MIN INFO DESKTOP / TABLET -->
	<div *ngIf="!onExtendedMobile() && minTemp" class="col-4 flex justify-content-end py-0">
		<div class="flex flex-column w-16rem">
			<div class="flex align-items-center justify-content-center text-lg">{{ 'MIN_VAR_AVAILABLE' | translate }}</div>
			<div class="flex align-items-center justify-content-center text-5xl">
				<div>{{minTemp}}°C</div>
			</div>
		</div>
	</div>
	<!-- SETPOINT BnB ROUND SLIDER -->
	<div *ngIf="showKnob" [class]="onExtendedMobile() ? 'col-12' : 'col-4'">
		<div class="flex flex-column align-items-center justify-content-center">
			<p-knob id="set-temperature-q&e-access" [(ngModel)]="manualTemp" valueTemplate="{{manualTemp}}°C"
				size="200" [min]="minTemp" [max]="maxTemp" [step]="step" class="cursor-pointer"
				textColor="var(--text-color, Black)" valueColor="#00B0ED" rangeColor="#CED1D4"
				(onChange)="onKnobChange($event)">
			</p-knob>
			<div class="flex align-items-center justify-content-around w-18rem">
				<p-button icon="pi cm-minus" severity="primary" [rounded]="false" [text]="false"
					(click)="setSliderButtonValue(buttonsTempSet.DECREASE)"
					[disabled]="manualTemp === minTemp"/>
				<p-button icon="pi cm-plus" severity="primary" [rounded]="false" [text]="false"
					(click)="setSliderButtonValue(buttonsTempSet.INCREASE)"
					[disabled]="manualTemp === maxTemp"/>
			</div>
		</div>
	</div>
	<!-- BnB MAX INFO DESKTOP / TABLET -->
	<div *ngIf="!onExtendedMobile() && maxTemp" class="col-4 flex justify-content-start">
		<div class="flex flex-column w-16rem">
			<div class="flex align-items-center justify-content-center text-lg">{{ 'MAX_VAR_AVAILABLE' | translate }}</div>
			<div class="flex align-items-center justify-content-center text-5xl font-normal">
				<div>{{maxTemp}}°C</div>
			</div>
		</div>
	</div>
</div>
